// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7257ef8e","389":"a511a8f7","732":"7c696646","977":"27d55f11"}[chunkId] + ".chunk.js";
};